import { render, staticRenderFns } from "./InfoCardPKB.vue?vue&type=template&id=0f1d6e58&scoped=true&"
import script from "./InfoCardPKB.vue?vue&type=script&lang=js&"
export * from "./InfoCardPKB.vue?vue&type=script&lang=js&"
import style0 from "./InfoCardPKB.vue?vue&type=style&index=0&id=0f1d6e58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1d6e58",
  null
  
)

export default component.exports